import { render, staticRenderFns } from "./ReviewNsaids.vue?vue&type=template&id=326cd986&"
import script from "./ReviewNsaids.vue?vue&type=script&lang=js&"
export * from "./ReviewNsaids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports